






import { Component, Vue, Prop } from 'vue-property-decorator'
import { NightVoteResult } from '@/class/game'
import { GamePlayerData } from '@/class/gamePlayer'
import Message from './Message.vue'

@Component({
  components: {
    Message
  }
})
export default class NightVoteLog extends Vue {
  @Prop() playerOf!: {[id: string]: GamePlayerData};
  @Prop() nightVoteResult!: NightVoteResult;

  get message () {
    if (this.nightVoteResult.suspectedPlayerId) {
      const suspectedPlayer = this.playerOf[this.nightVoteResult.suspectedPlayerId]
      return `${suspectedPlayer.name}さんが怪しまれています`
    } else {
      return `疑われている人は誰もいませんでした`
    }
  }
}
